import * as constants from '../constants/units';
import {pagination} from '../../config/settings';
import * as _ from 'lodash';

export const initialState = {
  item: null,
  list: [],
  totalCount: 0,
  loading: false,
  params: {
    ordering: 'id', limit: pagination.limit, offset: 0, search: null
  },
  pagesCount: 1,
  page: 1,
};

export default (state =  _.cloneDeep(initialState), action) => {
  switch (action.type) {
    case constants.GET_UNITS:
    case constants.GET_UNIT:
    case constants.UPDATE_UNIT:
    case constants.REMOVE_UNIT:
      return {
        ...state,
        loading: true
      };

    case constants.GET_UNITS_ERROR:
    case constants.GET_UNIT_ERROR:
    case constants.UPDATE_UNIT_ERROR:
    case constants.REMOVE_UNIT_ERROR:
      return {
        ...state,
        clearing: false,
        loading: false,
      };

    case constants.GET_UNITS_SUCCESS:
      return {
        ...state,
        loading: false,
        clearing: false,
        list: action.payload,
        item: null,
        totalCount: action.totalCount,
        pagesCount: Math.ceil(action.totalCount / pagination.limit)
      };

    case constants.GET_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [],
        item: action.payload,
      };

    case constants.EDIT_UNIT:
      return {
        ...state,
        item: action.data,
      };
    case constants.UNITS_CHANGE_PARAMS:
      return {
        ...state,
        params: action.data,
      };
    case constants.UNITS_UPDATE_PARAMS:
      return {
        ...state,
        params: action.data !== null ? _.merge(state.params, action.data) : _.cloneDeep(initialState.params)
      };
    case constants.UNITS_RESET_PARAMS:
      return {
        ...state,
        clearing: false,
        params: _.cloneDeep(initialState.params)
      };
    case constants.UNITS_CHANGE_PAGE:
      return {
        ...state,
        page: +action.data,
      };
    case constants.UNITS_CLEAR:
      return {
        ...state,
        clearing: true,
        totalCount: 0,
        pagesCount: 1,
        page: 1,
        item: null,
        list: [],
      };

    default:
      return state;
  }
};